import {
    UiDialog,
    UiText,
} from '@experiences/ui-common';
import {
    useInterval,
    useNavigateWithParams,
} from '@experiences/util';
import WarningIcon from '@mui/icons-material/Warning';
import { makeStyles } from '@mui/styles';
import createStyles from '@mui/styles/createStyles';
import React, {
    useCallback,
    useState,
} from 'react';
import { useIntl } from 'react-intl';

const useStyles = makeStyles(theme =>
    createStyles({
        yellowIcon: {
            color: theme.palette.semantic.colorWarningIcon,
            fontSize: '32px',
        },
        DeleteFailCountDown: { marginTop: '5px' },
    }),
);

export const OrgDeleteAlertDialog: React.FC = () => {
    const classes = useStyles();
    const { formatMessage: translate } = useIntl();
    const navigate = useNavigateWithParams();
    const [ countDownTime, setCountDownTime ] = useState(5);

    const close = useCallback(() => {
        navigate('/portal_/logout');
    }, [ navigate ]);

    useInterval(() => {
        if (countDownTime <= 0) {
            navigate('/portal_/logout');
        } else {
            setCountDownTime(countDownTime - 1);
        }
    }, 1000);

    return (
        <>
            <UiDialog
                close={close}
                title={translate({ id: 'CLIENT_ALERT' })}
                icon={<WarningIcon className={classes.yellowIcon} />}
            >
                <div>
                    <UiText data-cy="delete-org-fail-message">
                        {translate({ id: 'CLIENT_ORGANIZATION_DELETE_FAILURE_MESSAGE' })}
                    </UiText>
                    <UiText
                        data-cy="delete-org-fail-countdown"
                        className={classes.DeleteFailCountDown}>
                        {translate({ id: 'CLIENT_DELETE_ORG_FAIL_COUNTDOWN' }, { 0: countDownTime })}
                    </UiText>
                </div>
            </UiDialog>
        </>
    );
};
